// extracted by mini-css-extract-plugin
export default {"inputGroup":"StyledInput_inputGroup__6nFEz","inputIcon":"StyledInput_inputIcon__wb6co","something":"StyledInput_something__Eiehf"};